export default async function excel() {
  window.Excel.run(context => {
    console.log('Hello...')
    return context.workbook.worksheets.getActiveWorksheet()
  })
}
